export default {"src":"/_next/static/media/Mision.481ae458.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};